import { Card } from '../../../design-system/components/Card';
import { EmptyState } from '../../../shared/components/EmptyState';
import type { Summary } from '../api';

interface ReadOnlySummaryProps {
  summary: Summary | null | undefined;
}

export function ReadOnlySummary({ summary }: ReadOnlySummaryProps) {
  if (summary === null || summary === undefined) {
    return (
      <EmptyState
        title="Resumo ainda não gerado"
        description="Um resumo automático é gerado ao final da reunião."
      />
    );
  }
  const objections = summary.objections ?? [];
  const nextSteps = summary.next_steps ?? [];
  const keyPoints = summary.key_points ?? [];
  return (
    <div className="dash-section">
      <Card>
        <div className="dash-summary__section">
          <span className="label">Resumo executivo</span>
          <p>{summary.executive_summary}</p>
        </div>
      </Card>

      <Card>
        <div className="dash-summary__section">
          <span className="label">Pontos-chave</span>
          {keyPoints.length === 0 ? (
            <span className="muted">Nenhum ponto-chave.</span>
          ) : (
            <ul className="dash-summary__list">
              {keyPoints.map((kp, idx) => (
                <li key={`${kp.point}-${idx}`}>
                  <strong>{kp.point}</strong>
                  {kp.context !== null && kp.context !== undefined && kp.context.length > 0 ? (
                    <span className="muted"> — {kp.context}</span>
                  ) : null}
                </li>
              ))}
            </ul>
          )}
        </div>
      </Card>

      <Card>
        <div className="dash-summary__section">
          <span className="label">Objeções</span>
          {objections.length === 0 ? (
            <span className="muted">Nenhuma objeção registrada.</span>
          ) : (
            <ul className="dash-summary__list">
              {objections.map((o, idx) => (
                <li key={`${o.objection}-${idx}`}>
                  <strong>{o.objection}</strong>
                  {o.response !== null && o.response !== undefined && o.response.length > 0 ? (
                    <span className="muted"> — {o.response}</span>
                  ) : null}
                </li>
              ))}
            </ul>
          )}
        </div>
      </Card>

      <Card>
        <div className="dash-summary__section">
          <span className="label">Próximos passos</span>
          {nextSteps.length === 0 ? (
            <span className="muted">Sem próximos passos definidos.</span>
          ) : (
            <ul className="dash-summary__list">
              {nextSteps.map((ns, idx) => (
                <li key={`${ns.action}-${idx}`}>
                  <strong>{ns.action}</strong>
                  {ns.owner !== null && ns.owner !== undefined && ns.owner.length > 0 ? (
                    <span className="muted"> — responsável: {ns.owner}</span>
                  ) : null}
                </li>
              ))}
            </ul>
          )}
        </div>
      </Card>
    </div>
  );
}
